import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import assetsReducer from './feature/assetsSlice';
import playBookDetailReducer from './feature/playBookDetailSlice';
import taskReducer from './feature/taskSlice';
import notificationReducer from './feature/notificationSlice';
import directoryReducer from './feature/directory';
import dashboardReducer from './feature/dashboardSlice';
import purePlaybookReducer from './feature/purePlaybookSlice';
import pricingReducer from './feature/pricingSlice';
import templateLibraryReducer from './feature/templateLibrarySlice';
import userDealspaceReducer from './feature/dealspaceSlice';
import listTaskReducer from './feature/listTaskSlice';
import personalTemplatesDetailReducer from './feature/personalTemplatesDetailSlice';
import aIHistoryReducer from './feature/aiHistorySlice';

export const store = configureStore({
  reducer: {
    assetsReducer: assetsReducer,
    playBookDetailReducer: playBookDetailReducer,
    taskReducer: taskReducer,
    notificationReducer: notificationReducer,
    directoryReducer: directoryReducer,
    userDealspaceReducer: userDealspaceReducer,
    dashboardReducer: dashboardReducer,
    pricingReducer: pricingReducer,
    purePlaybookReducer: purePlaybookReducer,
    templateLibraryReducer: templateLibraryReducer,
    listTaskReducer: listTaskReducer,
    personalTemplatesDetailReducer: personalTemplatesDetailReducer,
    aIHistoryReducer: aIHistoryReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
